interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function pageList(current: number, total: number): (number | "ellipsis")[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | "ellipsis")[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("ellipsis");
  for (let p = start; p <= end; p += 1) pages.push(p);
  if (end < total - 1) pages.push("ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const items = pageList(page, totalPages);

  const go = (p: number) => {
    if (p < 1 || p > totalPages) return;
    onChange(p);
  };

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-1.5" aria-label="Pagination">
      <button
        type="button"
        onClick={() => go(page - 1)}
        disabled={page === 1}
        className="inline-flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm font-medium text-foreground-700 hover:border-primary-400 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        <span className="hidden sm:inline">Prev</span>
      </button>
      {items.map((it, i) =>
        it === "ellipsis" ? (
          <span key={`e-${i}`} className="px-1.5 text-foreground-400">
            &hellip;
          </span>
        ) : (
          <button
            key={it}
            type="button"
            onClick={() => go(it)}
            aria-current={it === page ? "page" : undefined}
            className={`inline-flex h-9 w-9 items-center justify-center rounded-md text-sm font-semibold cursor-pointer ${
              it === page
                ? "bg-primary-500 text-foreground-950"
                : "border border-background-300 text-foreground-700 hover:border-primary-400"
            }`}
          >
            {it}
          </button>
        ),
      )}
      <button
        type="button"
        onClick={() => go(page + 1)}
        disabled={page === totalPages}
        className="inline-flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm font-medium text-foreground-700 hover:border-primary-400 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <span className="hidden sm:inline">Next</span>
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}